import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      staticClass: "patient-profile-modal",
      attrs: {
        "data-qa": "patient-profile-modal",
        value: _vm.isVisible,
        title: `${_setup.t("Пациент", _setup.options)} ${
          _vm.patientData.title
        }`,
        transition: "fade-transition",
        size: "fullscreen",
        divider: "",
        persistent: "",
        "hide-overlay": "",
      },
      scopedSlots: _vm._u([
        {
          key: "prependBtn",
          fn: function ({ btnProps }) {
            return [
              _c(
                VBtn,
                _vm._b(
                  {
                    on: {
                      click: function ($event) {
                        _setup.isOpened = false
                      },
                    },
                  },
                  "v-btn",
                  btnProps,
                  false
                ),
                [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
              ),
            ]
          },
        },
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                VBtn,
                {
                  attrs: {
                    "data-qa": "modal-actions-btn-close",
                    color: "primary",
                    block: "",
                    depressed: "",
                  },
                  on: {
                    click: function ($event) {
                      _setup.isOpened = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Закрыть", _setup.options)) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      !_vm.patientData || !_vm.patientData.isLoaded
        ? _c(_setup.PatientProfileModalSkeleton)
        : [
            _c("div", { staticClass: "text-subtitle-1 mb-6" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Доверие к профилю", _setup.options)) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(_setup.PatientProfileTrustInfo, {
              staticClass: "mb-6",
              attrs: {
                "trust-percent": _vm.patientData.trust_percent,
                "can-trust": _vm.patientData.can_trust,
              },
            }),
            _vm._v(" "),
            _c(_setup.PatientProfileCriteria, {
              staticClass: "mb-10",
              attrs: { criteria: _vm.patientData.trust_criteria },
            }),
            _vm._v(" "),
            _c(_setup.PatinetProfileRatesStatistic, {
              staticClass: "mb-10",
              attrs: {
                "count-canceled": _vm.patientData.count_rates_canceled,
                "count-negative": _vm.patientData.count_rates_negative,
                "count-positive": _vm.patientData.count_rates_positive,
                "count-without-mark": _vm.patientData.count_rates_without_mark,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-space-between text--text text-subtitle-1",
              },
              [
                _c("span", { staticClass: "mr-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t("Записи на приём через", _setup.options)
                      ) +
                      " "
                  ),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_setup.isYDoc ? "YDoc" : "Продокторов") +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    attrs: { "data-qa": "patient_profile_count_appointments" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.patientData.count_appointments ||
                            _setup.t("Нет", _setup.options)
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }